import * as React from "react";
const SvgEllipse = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}><circle cx={12} cy={12} r={11} fill="#CBCBCB" stroke="#3555F0" strokeWidth={2} /></svg>;
export { SvgEllipse as ReactComponent };
export default __webpack_public_path__ + "assets/svg/ellipse9O7oViwjjEUpwUlp.svg";